export const UNSUBSCRIBE_IMPORT_LIST_PATH = "/unsubscribe-import";
export const UNSUBSCRIBE_IMPORT_CREATE_VIEW_PATH = "/unsubscribe-import/create";
